module.exports = function getResource(label, vars) {
    const resources = {
        editLinkText: 'Modifier',
        subTitle: 'Expédition standard – GRATUITE',
        title: 'Standard',
        autoReplenTitle: 'Livraison'
    };

    return resources[label];
};
